import { useMutation } from "@tanstack/react-query"
import { sendUserFeedback } from "../userFeedback"

export const useCreateUserFeedback = () => {
  return useMutation({
    mutationFn: sendUserFeedback,
  })
}
